import { defineComponent as _defineComponent } from 'vue'
import { GetEpubsResponse } from "@ilteducation/epub-guide-generator-types";
import { ref } from "vue";
import EditEpubGuideform from "@/components/epubguide/EditEpubGuideform.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditEpubGuideDialog',
  props: {
    selectedEpub: null
  },
  setup(__props: any) {



const dialog = ref<boolean>(false);

const closeMenu = () => {
  dialog.value = false;
};

return { __sfc: true,dialog, closeMenu, EditEpubGuideform }
}

})